import { render } from "./RichTextEditor.vue?vue&type=template&id=4c754fd7&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=ts"
export * from "./RichTextEditor.vue?vue&type=script&lang=ts"

import "./RichTextEditor.vue?vue&type=style&index=0&id=4c754fd7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c754fd7"

export default script